import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface GetDataExtractionModelParams {
	organization_id: string;
	company_id: string;
	data_extraction_model_id: string;
}

const Service = DataExtractionService.getInstance();

export const useGetDataExtractionModel = (params: GetDataExtractionModelParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_MODEL],
		queryFn: () => Service.findOneModel(params)
	});
};
